function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { INPUT } from "../../components/form-styles";

/*
 * Content Hub piece picker list (2026-10-04): the quarter's pieces ordered by
 * sessions/sales, with a search box (title + source/origin, client-side,
 * 200 ms debounce), type/kind chips derived from the items, and a
 * "with email copy only" chip when the rows expose an email variant.
 * Shared by the automation editor, the journey editor and the campaign wizard;
 * the host keeps its own pick/seed behaviour via onPick(item).
 */

export const CONTENT_PICK_TOP = 100;
function kindOf(c) {
  return String(c && (c.type || c.kind || c.origin) || "").trim().toLowerCase();
}
function hasEmail(c) {
  if (!c) return null;
  if (c.hasEmail != null) return !!c.hasEmail;
  if (c.emailVariantId != null) return !!c.emailVariantId;
  if (Array.isArray(c.variants)) return c.variants.some(v => String(v.channel || v.kind || "").toLowerCase() === "email" && (v.body || "").trim());
  if (Array.isArray(c.channels)) return c.channels.some(ch => String(ch.channel || ch).toLowerCase() === "email");
  return null;
}
export function pickMetric(c) {
  return Number(c.salesValue) > 0 ? `$${Math.round(Number(c.salesValue)).toLocaleString("en-US")}` : Number(c.conversions) > 0 ? `${Number(c.conversions).toLocaleString("en-US")} conv.` : `${Number(c.sessions || 0).toLocaleString("en-US")} sess.`;
}
export default class ContentPickList extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      q: "",
      term: "",
      kind: "",
      emailOnly: false
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onQ", e => {
      const q = e.target.value;
      this.setState({
        q
      });
      clearTimeout(this._t);
      this._t = setTimeout(() => this._alive && this.setState({
        term: q.trim().toLowerCase()
      }), 200);
    });
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._t);
  }
  render() {
    const {
      items,
      onPick,
      meta,
      pickTitle,
      maxHeight
    } = this.props;
    const {
      q,
      term,
      kind,
      emailOnly
    } = this.state;
    if (items == null) return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Loading\u2026");
    if (!items.length) return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "No content yet.");
    const kinds = [];
    items.forEach(c => {
      const k = kindOf(c);
      if (k && kinds.indexOf(k) < 0) kinds.push(k);
    });
    const emailKnown = items.some(c => hasEmail(c) != null);
    const rows = items.filter(c => {
      if (kind && kindOf(c) !== kind) return false;
      if (emailOnly && !hasEmail(c)) return false;
      if (term && `${c.title || ""} ${c.source || ""} ${c.origin || ""} ${c.topic || ""}`.toLowerCase().indexOf(term) < 0) return false;
      return true;
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "cmp-picklist"
    }, /*#__PURE__*/React.createElement("input", {
      style: INPUT,
      value: q,
      placeholder: "Search by title or source",
      onChange: this.onQ
    }), kinds.length > 1 || emailKnown ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-picklist-filters"
    }, kinds.length > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      className: "mtf-chip" + (!kind ? " on" : ""),
      onClick: () => this.setState({
        kind: ""
      })
    }, "All"), kinds.map(k => /*#__PURE__*/React.createElement("a", {
      key: k,
      className: "mtf-chip" + (kind === k ? " on" : ""),
      onClick: () => this.setState({
        kind: kind === k ? "" : k
      })
    }, k.replace(/_/g, " ")))) : null, emailKnown ? /*#__PURE__*/React.createElement("a", {
      className: "mtf-chip" + (emailOnly ? " on" : ""),
      onClick: () => this.setState({
        emailOnly: !emailOnly
      })
    }, "with email copy only") : null) : null, !rows.length ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "6px 0 0"
      }
    }, "No content matches.") : /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        maxHeight: maxHeight || 220,
        overflowY: "auto",
        marginTop: 6
      }
    }, rows.map(c => /*#__PURE__*/React.createElement("a", {
      key: String(c.id),
      className: "cust-row",
      style: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "6px 8px"
      },
      onClick: () => onPick(c),
      title: pickTitle || "Link this content"
    }, /*#__PURE__*/React.createElement("b", {
      style: {
        fontSize: 13,
        flex: "1 1 auto",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, c.title || "Untitled"), kindOf(c) && kinds.length > 1 ? /*#__PURE__*/React.createElement("span", {
      className: "code",
      style: {
        fontSize: 11,
        color: "var(--plk-text-subtle)",
        whiteSpace: "nowrap"
      }
    }, kindOf(c).replace(/_/g, " ")) : null, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0,
        whiteSpace: "nowrap"
      }
    }, meta ? meta(c) : pickMetric(c))))));
  }
}